export const services = {
  en: {
    embedded_development_services: {
      title:
        "Embedded Software Development Services in Poland | nRF, STM32, BLE",
    },
    embedded_software_outsourcing: {
      title:
        "Embedded Software Outsourcing Poland | nRF, STM32, Firmware Teams",
    },
    mvp_development: {
      title: "Bespoke MVP Development Company Poland | Custom Software MVP",
    },
    product_discovery_workshop: {
      title: "Product Discovery Workshops for Startups & Enterprises",
    },
    rtos_development: {
      title: "Expert RTOS Development Services",
    },
    ux_ui_design_services: {
      title: "UX/UI Design Services. Project and Implementation",
    },
  },
  pl: {
    mvp_development_pl: {
      title:
        "Firma MVP na zamówienie | Dedykowane usługi tworzenia oprogramowania MVP",
    },
    projektowanie_sprzetu: {
      title: "Ekspercka firma projektowa sprzętu | Własna elektronika",
    },
    rozwoj_oprogramowania_embedded: {
      title: "Rozwój oprogramowania embedded i IoT | Systemy wbudowane",
    },
    rozwoj_systemow_wbudowanych: {
      title: "Usługi rozwoju systemów wbudowanych",
    },
    rtos_development_pl: {
      title: "Rozwiązania embedded z RTOS",
    },
    ux_ui_design_uslugi: {
      title: "Profesjonalne usługi UX/UI design",
    },
  },
};
